export const pausasHibirdo = [
  {
    id: '1',
    descricao: 'FEEDBACK ATIVO',
  },
  {
    id: '2',
    descricao: '1 NR17 ATIVO',
  },
  {
    id: '3',
    descricao: '2 NR17 ATIVO',
  },
  {
    id: '4',
    descricao: 'BANHEIRO_AGUA ATIVO',
  },
  {
    id: '5',
    descricao: 'LANCHE ATIVO',
  },
  {
    id: '6',
    descricao: 'PAUSA ALMOCO',
  },
  {
    id: '7',
    descricao: 'PAUSA VENDA',
  },
  {
    id: '8',
    descricao: 'TREINAMENTO ATIVO',
  },
];
